import { Accordion } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const PeekAccordion = styled((props) => React.createElement(Accordion, Object.assign({ disableGutters: true }, props)))(({ theme }) => ({
    "& .MuiButtonBase-root.MuiAccordionSummary-root": {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.primary,
    },
    "&:before": {
        opacity: 0,
    },
    borderRadius: theme.spacing(0.8),
    backgroundColor: theme.palette.common.white,
    boxShadow: `0px 0px ${theme.spacing(0.1)} ${theme.palette.grey[100]}, 0px 0px ${theme.spacing(1.6)} ${theme.palette.grey[100]}`,
    "&.Mui-disabled": {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.grey[400],
    },
}));

export { PeekAccordion, PeekAccordion as default };
